/* Mystical Wishes: small behaviours for the mw- sections. No dependencies. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Ask Sandy chat ---------- */
  function initChat() {
    const chat = $('[data-mw-chat]');
    if (!chat) return;
    const panel = $('#MwChatPanel', chat);
    const toggle = $('[data-mw-chat-toggle]', chat);
    const label = $('.mw-chat__bubble-label', chat);

    // The panel eases in and out (CSS on .is-open); hidden is only set once the close has finished.
    let closeTimer;
    const isOpen = () => chat.classList.contains('is-open');
    const setOpen = (open, focus = true) => {
      clearTimeout(closeTimer);
      if (open) {
        panel.hidden = false;
        void panel.offsetWidth;
      } else {
        closeTimer = setTimeout(() => { if (!isOpen()) panel.hidden = true; }, 320);
      }
      chat.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      label.textContent = open ? label.dataset.openLabel : label.dataset.closedLabel;
      if (open && focus) {
        const first = $('input:not([type="hidden"]):not([disabled]), a, button.mw-chat__close', panel);
        if (first) first.focus({ preventScroll: true });
      }
      if (!open && focus) toggle.focus({ preventScroll: true });
    };

    toggle.addEventListener('click', () => setOpen(!isOpen()));
    $('[data-mw-chat-close]', chat)?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    // Any link to #ask-sandy (or marked data-mw-open-chat) opens the panel.
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href$="#ask-sandy"], [data-mw-open-chat]');
      if (!a) return;
      e.preventDefault();
      const topic = a.dataset.mwTopic;
      if (topic) {
        const radio = $(`[data-mw-topic="${topic}"]`, panel);
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      setOpen(true);
    });

    // Topic chips swap the extra field and the message hint.
    const form = $('#MwChatForm', panel);
    const applyTopic = () => {
      const on = $('[data-mw-topic]:checked', panel);
      if (!on) return;
      const n = on.dataset.mwTopic;
      $$('[data-mw-topic-field]', panel).forEach((field) => {
        const show = field.dataset.mwTopicField === n;
        field.hidden = !show;
        $$('input, select, textarea', field).forEach((el) => { el.disabled = !show; });
      });
      const msg = $('[data-mw-hint]', panel);
      const hint = msg && msg.getAttribute(`data-hint-${n}`);
      if (hint) msg.placeholder = hint;
    };
    if (form) {
      form.addEventListener('change', (e) => { if (e.target.matches('[data-mw-topic]')) applyTopic(); });
      applyTopic();
    }

    // Send in place. Shopify answers a contact POST with a redirect carrying contact_posted=true;
    // anything else (an hCaptcha challenge, an error page) falls back to a normal submit.
    const thanks = $('[data-mw-chat-thanks]', panel);
    if (form && thanks) {
      form.addEventListener('submit', (e) => {
        if (form.dataset.native === '1' || !window.fetch) return;
        e.preventDefault();
        const button = $('[type="submit"]', form);
        if (button) button.disabled = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then((r) => {
            if (r.ok && r.url.indexOf('contact_posted=true') !== -1) {
              const name = ($('[name="contact[name]"]', form) || {}).value || '';
              const slot = $('[data-mw-chat-name]', thanks);
              if (slot) slot.textContent = name ? `, ${name.split(' ')[0]}` : '';
              form.hidden = true;
              thanks.hidden = false;
              form.reset();
            } else {
              form.dataset.native = '1';
              form.submit();
            }
          })
          .catch(() => { form.dataset.native = '1'; form.submit(); })
          .finally(() => { if (button) button.disabled = false; });
      });
      $('[data-mw-chat-again]', thanks)?.addEventListener('click', () => {
        thanks.hidden = true;
        form.hidden = false;
        applyTopic();
      });
    }

    // Reopen after a normal (fallback) post, success or error.
    const posted = $('[data-mw-chat-sent], [data-mw-chat-error]', panel);
    if ((posted && window.location.hash !== '#MwQuoteForm') || window.location.hash === '#MwChatForm' || window.location.hash === '#ask-sandy') setOpen(true, false);
  }

  /* ---------- back to top ---------- */
  function initTop() {
    $$('[data-mw-top]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    }));
  }

  /* ---------- country selector ---------- */
  function initAutosubmit() {
    $$('[data-mw-autosubmit]').forEach((sel) => sel.addEventListener('change', () => sel.form && sel.form.submit()));
  }

  /* ---------- mega menu opens on hover (desktop, fine pointer) ---------- */
  function initMegaHover() {
    const mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
    const items = $$('.mw-header header-menu');
    items.forEach((menu) => {
      const details = $('details', menu);
      const li = menu.closest('li');
      if (!details || !li) return;
      let timer;
      li.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        clearTimeout(timer);
        items.forEach((other) => {
          const d = $('details', other);
          if (d && d !== details && d.open) { d.open = false; $('summary', d)?.setAttribute('aria-expanded', 'false'); }
        });
        if (!details.open) { details.open = true; $('summary', details)?.setAttribute('aria-expanded', 'true'); }
      });
      li.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        timer = setTimeout(() => {
          if (details.open && !li.contains(document.activeElement)) {
            details.open = false;
            $('summary', details)?.setAttribute('aria-expanded', 'false');
          }
        }, 160);
      });
    });
  }

  /* ---------- tabs (product lists) ---------- */
  function initTabs(root = document) {
    $$('[data-mw-tabs]', root).forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          next.focus(); select(next);
        });
      });
    });
  }

  /* ---------- personalisation fields on the product page ---------- */
  function initPersonalise(root = document) {
    $$('[data-mw-personalise]', root).forEach((box) => {
      const kinds = $$('[data-mw-kind]', box);
      const apply = () => {
        const on = kinds.find((k) => k.checked);
        if (!on) return;
        const kind = on.dataset.mwKind; // photo | text | both
        $$('[data-mw-when]', box).forEach((field) => {
          const w = field.dataset.mwWhen; // photo | text
          const show = (w === 'photo' && kind !== 'text') || (w === 'text' && kind !== 'photo');
          field.hidden = !show;
          $$('input, textarea, select', field).forEach((el) => { el.disabled = !show; });
        });
      };
      kinds.forEach((k) => k.addEventListener('change', apply));
      apply();

      $$('.mw-upload input[type="file"]', box).forEach((input) => {
        const wrap = input.closest('.mw-upload');
        const title = $('[data-mw-upload-title]', wrap);
        const initial = title ? title.textContent : '';
        input.addEventListener('change', () => {
          const file = input.files && input.files[0];
          wrap.classList.toggle('is-filled', !!file);
          if (title) title.textContent = file ? file.name : initial;
        });
      });

      $$('[data-mw-count]', box).forEach((input) => {
        const out = document.getElementById(input.dataset.mwCount);
        if (!out) return;
        const update = () => { out.textContent = String(input.value.length); };
        input.addEventListener('input', update);
        update();
      });
    });
  }

  /* Required personalisation fields. Dawn's product form is novalidate and posts by fetch, so
     check here, in the capture phase, before Dawn's submit handler runs. */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    // getAttribute, not form.id: Dawn's product form has an <input name="id">, which shadows .id
    const formId = form.getAttribute && form.getAttribute('id');
    if (!formId) return;
    const box = document.querySelector(`[data-mw-personalise][data-form="${formId}"]`);
    if (!box) return;
    const missing = $$('[data-mw-required]', box).filter((el) => {
      if (el.disabled || el.closest('[hidden]')) return false;
      if (el.type === 'file') return !(el.files && el.files.length);
      return !el.value.trim();
    });
    const msg = $('[data-mw-personalise-error]', box);
    if (missing.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (msg) msg.hidden = false;
      missing[0].focus();
      missing[0].closest('.mw-pfield')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else if (msg) {
      msg.hidden = true;
    }
  }, true);

  /* ---------- accordions slide open and closed (round 2) ---------- */
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initAccordions(root = document) {
    $$('details.accordion, .mw-faq details', root).forEach((d) => {
      if (d.dataset.mwAcc) return;
      d.dataset.mwAcc = '1';
      const summary = $('summary', d);
      if (!summary) return;
      let anim;
      summary.addEventListener('click', (e) => {
        if (calm.matches || !d.animate) return;
        e.preventDefault();
        const closing = d.open && !d.classList.contains('is-closing');
        const start = d.offsetHeight;
        if (anim) anim.cancel();
        if (!closing) { d.classList.remove('is-closing'); d.open = true; }
        else d.classList.add('is-closing');
        const cs = getComputedStyle(d);
        const shut = summary.offsetHeight + ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'].reduce((t, k) => t + parseFloat(cs[k]), 0);
        const end = closing ? shut : d.offsetHeight;
        d.style.overflow = 'hidden';
        anim = d.animate({ height: [`${start}px`, `${end}px`] }, { duration: closing ? 260 : 340, easing: 'cubic-bezier(.2,.7,.2,1)' });
        anim.onfinish = () => {
          if (closing) d.open = false;
          d.classList.remove('is-closing');
          d.style.overflow = '';
          anim = null;
        };
      });
    });
  }

  const boot = () => {
    initAccordions();
    initChat();
    initTop();
    initAutosubmit();
    initMegaHover();
    initTabs();
    initPersonalise();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run section-level behaviours when a section reloads.
  document.addEventListener('shopify:section:load', (e) => { initTabs(e.target); initPersonalise(e.target); initAccordions(e.target); });
})();
